import React from "react";
import { NavLink } from "react-router-dom";
import { Home, CalendarDays, Users, BarChart3, Menu } from "lucide-react";

const items = [
  { to: "/", label: "Home", icon: Home, testid: "bottom-nav-home", end: true },
  { to: "/attendance", label: "Attendance", icon: CalendarDays, testid: "bottom-nav-attendance" },
  { to: "/team", label: "Team", icon: Users, testid: "bottom-nav-team" },
  { to: "/reports", label: "Reports", icon: BarChart3, testid: "bottom-nav-reports" },
  { to: "/more", label: "More", icon: Menu, testid: "bottom-nav-more" },
];

export function BottomNav() {
  return (
    <div
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40"
      style={{
        background: "#111520",
        borderTop: "1px solid #1E2640",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="bottom-nav"
    >
      <div className="flex justify-between items-stretch px-2 h-16">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            data-testid={it.testid}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center gap-1 relative ${isActive ? "text-[#4F8EF7]" : "text-[#7A85A3]"}`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[2px] rounded-full" style={{ background: "#4F8EF7" }} />
                )}
                <it.icon size={20} strokeWidth={isActive ? 2.4 : 1.8} />
                <span className="text-[10px] font-medium">{it.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
